import React from 'react';

function SearchJobV2Icon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="iconamoon:search-bold">
        <path
          id="Vector"
          d={`M17.5002 17.5L13.881 13.8808M13.881 13.8808C14.5001 13.2618 14.9912 12.5268 15.3262 11.718C15.6612
               10.9091 15.8337 10.0422 15.8337 9.16667C15.8337 8.29117 15.6612 7.42424 15.3262 6.61538C14.9912 5.80652
                14.5001 5.07158 13.881 4.4525C13.2619 3.83343 12.527 3.34236 11.7181 3.00732C10.9093 2.67228 10.0423
                 2.49983 9.16684 2.49983C8.29134 2.49983 7.42441 2.67228 6.61555 3.00732C5.80669 3.34236 5.07174
                  3.83343 4.45267 4.4525C3.2024 5.70278 2.5 7.39851 2.5 9.16667C2.5 10.9348 3.2024 12.6306 4.45267
                   13.8808C5.70295 15.1311 7.39868 15.8335 9.16684 15.8335C10.935 15.8335 12.6307 15.1311 13.881
                    13.8808Z`}
          stroke="#003B58"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export default SearchJobV2Icon;
